import toast from "react-hot-toast";

const { clientAPI } = require("../client");
export const customerUpdateRequestCall = {
  create: async (data) => {
    try {
      const response = await clientAPI("post", "/customerUpdateRequest", data);
      return response;
    } catch (error) {
      console.error("Create error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  update: async (id, data) => {
    try {
      const response = await clientAPI("put", `/customerUpdateRequest/${id}`, data);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  delete: async (id) => {
    try {
      const response = await clientAPI("delete", `/customerUpdateRequest/${id}`);
      return response;
    } catch (error) {
      console.error("Update error:", error);
      const errorMessages = error?.response?.data?.errors?.map(
        (err) => err.message
      ) || [
        error?.response?.data?.message ||
          error?.response?.statusText ||
          error?.message ||
          "An unexpected error occurred.",
      ];

      errorMessages.forEach((message) => {
        toast.error(`${message}`);
      });
      throw error;
    }
  },
  approve: async (id,data) => {
      try {
        const response = await clientAPI("put", `/customerUpdateRequest/updateStatus/${id}`, data);
        return response;
      } catch (error) {
        console.error("Update error:", error);
        const errorMessages = error?.response?.data?.errors?.map(
          (err) => err.message
        ) || [
          error?.response?.data?.message ||
            error?.response?.statusText ||
            error?.message ||
            "An unexpected error occurred.",
        ];
  
        errorMessages.forEach((message) => {
          toast.error(`${message}`);
        });
        throw error;
      }
    },
};
